import { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';

import Container from '@mui/material/Container';
import Paper from '@mui/material/Paper';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Tooltip from '@mui/material/Tooltip';
import Stack from '@mui/material/Stack';
import { GridColDef } from '@mui/x-data-grid';

import Modal from '../../common/Modal';
import SearchField from '../../common/searchField';
import DataTable from '../../components/DataTable';

import { DEFAULT_PAGE_NUMBER, DEFAULT_PAGE_SIZE } from '../../utils/table-utils';
import { connectivityDashboardActions } from '../../store/reducers/connectivity-dashboard';
import { MQBrokerRequestPayloadTypes } from '../../store/models/connectivity-dashboard';
import { useLocation, useOutletContext, useParams } from 'react-router-dom';
import { pageActions } from '../../store/reducers/page-actions';
import { palette } from '../../theme/palette';
import { ontologyMasterActions } from '../../store/reducers/ontology-master';
// import IconButton from '@mui/material/IconButton';
// import { ReactComponent as ViewIcon } from '../../assets/eye-icon.svg';
// import get from 'lodash/get';
import LatestMessagePopup from './latestMessagePopup';

import { ReactComponent as EmqxConnectedIcon } from '../../assets/connectivitydashboard/emqx-connected-icon.svg';
import { ReactComponent as EmqxDisconnectedIcon } from '../../assets/connectivitydashboard/emqx-disconnected-icon.svg';
import { lighten, useTheme } from '@mui/material';
import get from 'lodash/get';

const Styles = {
  container: { boxShadow: '0px 0px 14px 0px rgba(0, 0, 0, 0.02)', borderRadius: '18px' },
  paper: {
    margin: 'auto',
    boxShadow: '0px 0px 14px 0px #0000000D',
    borderRadius: '18px',
    border: `1px solid #D9DFED`,
    // height: '80vh',
    overflow: 'hidden',
  },
  header: {
    p: 3,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid rgba(0, 0, 0, 0.12)',
    boxSizing: 'border-box',
    // height: '87px',
  },
  searchFieldWrapper: { display: 'flex', alignItems: 'center', columnGap: 3 },
  dataTableWrapper: {
    height: '100%',
    overflow: 'hidden',
  },
  dataTable: {
    '& .MuiDataGrid-virtualScroller': {
      overflow: 'auto',
      overflowY: 'hidden',
      minHeight: 'calc(100vh - 420px)',
      paddingBottom: '10px',
      height: '100%',
    },
    '&.MuiDataGrid-root': {
      // height:'100%',
      minHeight: 'calc(100vh - 278px)',
    },
  },
  closeBtnWrapper: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBlock: 4,
    borderTop: '1px solid #D9DFED',
  },
  tableCellText: {
    fontSize: '16px',
    fontWeight: 400,
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
  },
};

interface MQBrokerLabelTypes {
  all: string;
  connected: string;
  disconnected: string;
}

const mqBrokerLabel: MQBrokerLabelTypes = {
  all: '',
  connected: 'CONNECTED',
  disconnected: 'DISCONNECTED',
};

const MQBrokerTable = ({
  ontologyData,
  ontologies,
  mqBroker,
  mqBrokerLoading,
  mqBrokerPageNumber,
  mqBrokerTotalCount,
}: any) => {
  const theme = useTheme();
  const themeMode: any = get(useOutletContext(), 'themeMode', {});
  const dispatch = useDispatch();
  const [sortingModel, setSortingModel] = useState({ field: '', sort: '' });
  const [searchValue, setSearchValue] = useState('');
  const { onto_manage_id, type } = useParams();
  const { pathname } = useLocation();
  const [rows, setRows] = useState([]);
  const [popupMsgData, setPopupMsgData] = useState<any>({
    status: false,
    title: 'MQTT MESSAGE',
    type: 'MQTT',
    item: {},
    connectivityStatus: '',
  });

  const dispatchMQBrokerRequest = (payload: MQBrokerRequestPayloadTypes) => {
    dispatch(
      connectivityDashboardActions.getMQBrokerRequest({
        onto_manage_id: Number(onto_manage_id),
        search_item: searchValue,
        connectivity_status: type,
        ...sortingModel,
        ...payload,
      })
    );
  };

  const onSearch = (value: string) => {
    dispatchMQBrokerRequest({ limit: DEFAULT_PAGE_SIZE, page: DEFAULT_PAGE_NUMBER, search_item: value });
    setSearchValue(value);
  };

  useEffect(() => {
    if (type) {
      dispatchMQBrokerRequest({ limit: DEFAULT_PAGE_SIZE, page: DEFAULT_PAGE_NUMBER });
      dispatch(ontologyMasterActions.getOntologyMgmntList(''));
      dispatch(ontologyMasterActions.getOntologyList(''));
    }

    return () => {
      dispatch(connectivityDashboardActions.resetMQTable());
    };
  }, [type]);

  useEffect(() => {
    if (pathname.length) {
      const pathnamesTemp: any = pathname.split('/').filter(Boolean);
      if (pathnamesTemp.length) {
        const pathnamesData: any = pathnamesTemp
          .filter((i: any, index: number) => index != 2 && index != 3)
          .map((item: any, index: number) => {
            if (index == 0) {
              return { route: pathnamesTemp[0], pathName: item.replace('-', ' '), navigate: true };
            } else if (index == 1) {
              return { route: '', pathName: 'Mqbroker', navigate: false };
            } else {
              return { route: '', pathName: type, navigate: false };
            }
          });
        dispatch(pageActions.setPagePath(pathnamesData));
        return () => {
          const data: any = [];
          dispatch(pageActions.setPagePath(data));
        };
      }
    }
  }, [pathname]);

  // const getOntologyData = (ontoId: any) => {
  //   if (ontologies.length > 0) {
  //     let tempOntoData: any = [];
  //     restartTheLoop: while (true) {
  //       for (const item of ontologies) {
  //         if (item.onto_manage_id == ontoId) {
  //           tempOntoData.unshift(item);
  //           ontoId = item.parent_id;
  //           continue restartTheLoop;
  //         }
  //       }
  //       break;
  //     }

  //     tempOntoData.map((item: any) => {
  //       let getLevelName = ontologyData.filter((data: any) => {
  //         return data.id === item.onto_level_number;
  //       })[0];

  //       return {
  //         ...item,
  //         level_name: getLevelName?.level_name || '',
  //       };
  //     });

  //     return tempOntoData;
  //   }
  //   return [];
  // };

  // useEffect(() => {
  //   if (mqBroker.length && ontologies.length) {
  //     setRows(
  //       mqBroker.map((item: any) => {
  //         return {
  //           ...item,
  //           ontologyList: getOntologyData(item.onto_manage_id),
  //         };
  //       })
  //     );
  //   }
  // }, [mqBroker, ontologies]);

  const handleLogsPopupOpen = (type: any, msg: any) => {
    setPopupMsgData({ status: true, title: 'MQTT MESSAGE', type: type, item: msg });
  };

  const columns: GridColDef[] = [
    {
      field: 'uid',
      headerName: 'ID',
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      minWidth: 100,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <Typography component='p' sx={Styles.tableCellText}>
            {params.value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'container',
      headerName: 'Container',
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      minWidth: 100,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <Typography component='p' sx={Styles.tableCellText}>
            {params.value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'endpoint',
      headerName: 'End Point',
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      minWidth: 100,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <Typography component='p' sx={Styles.tableCellText}>
            {params.value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'image_spec',
      headerName: 'Image Spec',
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      minWidth: 100,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <Typography component='p' sx={Styles.tableCellText}>
            {params.value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'namespace',
      headerName: 'Name Space',
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      minWidth: 100,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <Typography component='p' sx={Styles.tableCellText}>
            {params.value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'service',
      headerName: 'Service',
      flex: 1,
      headerAlign: 'left',
      align: 'left',
      minWidth: 100,
      renderCell: (params) => (
        <Tooltip title={params.value} arrow>
          <Typography component='p' sx={Styles.tableCellText}>
            {params.value}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'location',
      headerName: 'Location',
      headerAlign: 'left',
      align: 'left',
      minWidth: 200,
      flex: 1,
      renderCell: (params: any) => {
        // const ontoList =
        //   params.row.ontologyList && params.row.ontologyList.length
        //     ? params.row.ontologyList.map((item: any, index: number) =>
        //         params.row.ontologyList.length > 1 ? (
        //           index === params.row.ontologyList.length - 1 ? (
        //             <span key={item.onto_manage_title}>{item.onto_manage_title} </span>
        //           ) : (
        //             <span key={item.onto_manage_title}>{item.onto_manage_title} / </span>
        //           )
        //         ) : (
        //           <span key={item.onto_manage_title}>{item.onto_manage_title}</span>
        //         )
        //       )
        //     : '';

        // return (
        //   <Box sx={{ textWrap: 'wrap', lineHeight: '1.2', width: '280px' }}>
        //     <Tooltip title={ontoList} placement='left' arrow>
        //       <Typography
        //         component='p'
        //         sx={{
        //           textOverflow: 'ellipsis',
        //           fontSize: '16px !important',
        //           fontWeight: '400',
        //           lineHeight: '1.5',
        //           overflow: 'hidden',
        //           whiteSpace: 'nowrap',
        //         }}
        //       >
        //         {ontoList}
        //       </Typography>
        //     </Tooltip>
        //   </Box>
        // );
        return (
          <Tooltip title={params.value} arrow>
            <Typography component='p' sx={Styles.tableCellText}>
              {params.value}
            </Typography>
          </Tooltip>
        );
      },
    },
    {
      field: 'connectivity_status',
      headerName: 'Connectivity Status',
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) =>
        params.value === 'connected' ? (
          <EmqxConnectedIcon style={{ color: theme.palette.success.main }} />
        ) : (
          <EmqxDisconnectedIcon style={{ color: theme.palette.error.main }} />
        ),
      minWidth: 300,
      flex: 1,
    },
  ];

  return (
    <Container maxWidth={false} disableGutters sx={Styles.container}>
      <Paper
        sx={{
          ...Styles.paper,
          border: `1px solid  ${theme.palette.customBorderColor.main}`,
          backgroundColor: themeMode.isLightBG
            ? lighten(theme.palette.background.default, 0.9)
            : lighten(theme.palette.background.default, 0.05),
        }}
      >
        <Box sx={Styles.header}>
          <Box>
            <Typography component='h4' fontSize='18px' color={theme.palette.text.primary}>
              List of <span style={{ textTransform: 'capitalize' }}>{type === 'viewall' ? '' : type}</span> Mqbrokers
            </Typography>
          </Box>
          <Box sx={Styles.searchFieldWrapper}>
            <SearchField searchPlaceholder='Search' onSearch={onSearch} width='100%' />
          </Box>
        </Box>
        <Box sx={Styles.dataTableWrapper}>
          <DataTable
            columns={columns}
            rows={mqBroker}
            loading={mqBrokerLoading}
            tableStyles={Styles.dataTable}
            noRowsOverlay={() => (
              <Stack height='100%' alignItems='center' justifyContent='center'>
                No MQ Broker Data
              </Stack>
            )}
            isServerPagination
            totalRowCount={mqBrokerTotalCount}
            pageNumber={mqBrokerPageNumber}
            onPagination={(pageSize: number, pageNumber: number) => {
              dispatchMQBrokerRequest({
                limit: pageSize,
                page: pageNumber,
              });
            }}
            onSorting={(sortModel: { field: string; sort: string }) => {
              dispatchMQBrokerRequest({
                limit: DEFAULT_PAGE_SIZE,
                page: mqBrokerPageNumber,
                ...sortModel,
              });
              setSortingModel(sortModel);
            }}
            otherProps={{
              getRowId: (row: any) => row.id,
            }}
          />
        </Box>
      </Paper>

      <LatestMessagePopup
        popupMsgData={popupMsgData}
        handleMsgPopupClose={() => {
          setPopupMsgData({ status: false, title: '', type: '', item: {} });
        }}
      />
    </Container>
  );
};

const mapStateToProps = (state: any) => ({
  mqBroker: state.connectivityDashboard.mqBroker,
  mqBrokerLoading: state.connectivityDashboard.mqBrokerLoading,
  mqBrokerPageNumber: state.connectivityDashboard.mqBrokerPageNumber,
  mqBrokerTotalCount: state.connectivityDashboard.mqBrokerTotalCount,
  ontologyData: state.ontologyMaster.ontologyData,
  ontologies: state.ontologyMaster.ontologyMgmntData,
});

export default connect(mapStateToProps)(MQBrokerTable);
